import { AppBox } from "../../../../../commons/components";
import { ManageFootballSubTeam } from "../../../../../commons/models/football/admin/manage-football-sub-team";

interface TeamActivateProps {
  subTeam: ManageFootballSubTeam;
}
export default function SubTeamActivate({ subTeam }: TeamActivateProps) {
  return (
    <AppBox displayBlock>
      Once you activate sub-team <strong>“{subTeam.name}”</strong>, the team will be able to participate in any
      tournament.
    </AppBox>
  );
}
